import React, {useId} from 'react';

function formatDate(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString();
}

/**
 * Checklist of orders waiting to ship. Controlled: `selected` is a Set of order uuids.
 * `needsAddress` flags orders that have no address label (masked or missing address).
 */
export default function LabelOrderPicker({items, selected, onChange, needsAddress = false}) {
  const uid = useId();
  const toggle = uuid => {
    const next = new Set(selected);
    if (next.has(uuid)) next.delete(uuid);
    else next.add(uuid);
    onChange(next);
  };

  return (
    <div className="label-order-picker">
      <div className="label-order-picker__header">
        <h3>Orders to print</h3>
        <span className="label-order-picker__count">
          {selected.size} of {items.length} selected
        </span>
        <button type="button" onClick={() => onChange(new Set(items.map(item => item.uuid)))}>
          Select all
        </button>
        <button type="button" onClick={() => onChange(new Set())}>
          Select none
        </button>
      </div>

      <ul className="label-order-picker__list">
        {items.map(item => {
          const id = `${uid}-order-${item.uuid}`;
          const missingAddress = needsAddress && !item.labels.address;
          return (
            <li key={item.uuid}>
              <label className="checkbox" htmlFor={id}>
                <input
                  type="checkbox"
                  id={id}
                  checked={selected.has(item.uuid)}
                  onChange={() => toggle(item.uuid)}
                />
                <span>
                  <strong>{item.recipientName || 'Customer'}</strong>
                  {' '}
                  {item.productName}
                  {item.quantity > 1 && ` (x${item.quantity})`}
                  {formatDate(item.createdAt) && ` ${formatDate(item.createdAt)}`}
                  {missingAddress && (
                    <em className="label-order-picker__warning"> No address label available</em>
                  )}
                </span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
